module.exports = __webpack_public_path__ + "static/img/笔筒.d6c2317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/模型库/笔筒.png
// module id = F2pU
// module chunks = 1